module.exports = __webpack_public_path__ + "static/media/instagram.c144a099.svg";